import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UploadReqStepActivateComponent } from './upload-req-step-activate.component';

@NgModule({
  declarations: [UploadReqStepActivateComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [UploadReqStepActivateComponent],
  entryComponents: [UploadReqStepActivateComponent]
})
export class UploadReqStepActivateModule { }
